document.addEventListener('DOMContentLoaded', function () {
  const wishlistButtons = document.querySelectorAll('.wishlist-btn');

  wishlistButtons.forEach(button => {
    button.addEventListener('click', function () {
      const product = {
        handle: this.dataset.productHandle,
        title: this.dataset.productTitle,
        url: this.dataset.productUrl,
        image: this.dataset.productImage
      };

      let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

      const exists = wishlist.some(item => item.handle === product.handle);

      if (!exists) {
        wishlist.push(product);
        localStorage.setItem('wishlist', JSON.stringify(wishlist));
        alert('✅ Added to Wishlist!');
      } else {
        alert('⚠️ Already in Wishlist!');
      }

      // 1 saniye sonra yönlendir
      setTimeout(() => {
        window.location.href = '/pages/wishlist';
      }, 1000);
    });
  });
});
